import { Link, Outlet } from 'react-router'
import { useOptionalUser, userHasRole } from '#app/utils/user.ts'
import { type Route } from './+types/_layout.ts'

export const meta: Route.MetaFunction = () => [{ title: 'Events | EBHS' }]

export default function EventsLayout() {
	const user = useOptionalUser()
	const isEventAdmin = userHasRole(user ?? null, 'event-admin')

	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<div className="flex items-center justify-between">
						<h2 className="text-3xl font-bold leading-tight text-gray-900">
							<Link to="/events" className="cursor-pointer">
								Events
							</Link>
						</h2>
						{isEventAdmin ? (
							<Link
								to="/admin/events"
								className="inline-flex items-center rounded-md bg-ebhs-blue px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-ebhs-blue-dark"
							>
								Manage Events
							</Link>
						) : null}
					</div>
				</div>
			</header>
			<Outlet />
		</>
	)
}
